import { forwardRef, type SVGProps } from 'react';

export const User = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g fill="currentColor">
      <path d="M10.448 12.789a3.141 3.141 0 0 1 .433-.58.5.5 0 0 0-.124-.781 7.371 7.371 0 0 0-3.552-.928 7.542 7.542 0 0 0-7.184 5.357.5.5 0 0 0 .479.643h9.348a.5.5 0 0 0 .455-.709 3.253 3.253 0 0 1 .145-3.002z" />
      <circle cx="6.999" cy="4.75" r="4.75" />
      <circle cx="17.748" cy="17.031" r="1.5" />
      <path d="M23.516 15.654a1.783 1.783 0 0 0-1.7-2.953l-1.411.327a.453.453 0 0 1-.533-.311l-.424-1.393a1.776 1.776 0 0 0-3.4 0l-.424 1.393a.454.454 0 0 1-.533.311l-1.41-.328a1.783 1.783 0 0 0-1.7 2.953l.988 1.065a.463.463 0 0 1 0 .625l-.988 1.064a1.783 1.783 0 0 0 1.7 2.953l1.411-.327a.454.454 0 0 1 .533.312l.424 1.392a1.775 1.775 0 0 0 3.4 0l.424-1.392a.452.452 0 0 1 .533-.312l1.411.327a1.783 1.783 0 0 0 1.7-2.953l-.987-1.064a.463.463 0 0 1 0-.625zm-5.768 4.377a3 3 0 1 1 3-3 3 3 0 0 1-3 3z" />
    </g>
  </svg>
));
